import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  layout: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 80px)',
    [theme.breakpoints.down('lg')]: {
      minHeight: 'calc(100vh - 70px)',
    },
    [theme.breakpoints.down('md')]: {
      minHeight: 'calc(100vh - 54px)',
    },
  },
  text: {
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(3),
      textAlign: 'center',
      width: 210,
    },
  },
  button: {
    padding: '10px 16px',
    maxHeight: 44,
    width: 130,
  },
}));
